import {Component, NgModule, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {AuthService} from "../services/auth.service";
import {AlertService} from "../services/alert.service";
import {DialogService} from "../services/dialog.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {EnvService} from "../services/env.service";
import {SysService} from "../services/sys.service";

@Component({
  templateUrl: 'crypto.component.html'
})

export class CryptoComponent implements OnInit {

  encryptedValue:string;
  decryptedValue:string;
  protected hasAdmin:boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public env:EnvService,
    public authService: AuthService,
    private http: HttpClient,
    private alertService: AlertService,
    private dialogService: DialogService,
    private sysService: SysService,
  ) { }

  ngOnInit() {
    this.hasAdmin = this.authService.hasService("PLATFORM_ADMIN");
  }

  decrypt() {
    let params:HttpParams = new HttpParams()
      .set("value", this.encryptedValue);

    return this.http.get(`${this.env.e.url}/auth/crypto/decrypt`,
      {params:params})
      .subscribe(data => {
        // console.log(data)
        this.decryptedValue = (data as any).result;
      });
  }
  encrypt() {
    let params:HttpParams = new HttpParams()
      .set("value", this.decryptedValue);

    return this.http.get(`${this.env.e.url}/auth/crypto/encrypt`,
      {params:params})
      .subscribe(data => {
        // console.log(data)
        this.encryptedValue = (data as any).result;
      });
  }
}

